module.exports = __webpack_public_path__ + "img/83e691c.jpg";